import React, { useState, useEffect } from 'react';
import { Drawer, Form, Input, Select, Button } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { updateOverride } from '../../../redux/Overrides/actions';
import { fetchCapabilities } from '../../../redux/Capabilities/actions';
import { fetchResources } from '../../../redux/resources/actions';
import { fetchOverrides } from '../../../redux/Overrides/actions';

const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
};

export const EditOverride = ({ item }) => {
    const dispatch = useDispatch();
    const [drawerVisible, setDrawerVisible] = useState(false);
    const [form] = Form.useForm();
    const capabilities = useSelector((state) => state.capabilities.capabilities || []);
    const resources = useSelector((state) => state.resources.resources || []);
  
    useEffect(() => {
      dispatch(fetchCapabilities());
      dispatch(fetchResources());
    }, [dispatch]);
  
    const showDrawer = () => {
      onFill();
      setDrawerVisible(true);
    };
  
    const onFill = () => {
      form.setFieldsValue({
        ...item,
        defaultCapabilities: item.defaultCapabilities ? item.defaultCapabilities.map(capability => capability._id) : [],
        defaultRessources: item.defaultRessources ? item.defaultRessources.map(resource => resource._id) : [],
      });
    };
  
    const hideDrawerOk = () => {
      form.submit();
    };
  
    const formOnFinish = (values) => {
      dispatch(updateOverride(item._id, values)).then(() => {
        dispatch(fetchOverrides()); // Fetch the latest overrides after editing
      });
      form.resetFields();
      setDrawerVisible(false);
    };
  
    const hideDrawerCancel = () => {
      setDrawerVisible(false);
      form.resetFields();
    };
  
    return (
      <>
        <Button type="primary" onClick={showDrawer}>
          Edit
        </Button>
        <Drawer
          title="Edit Override"
          visible={drawerVisible}
          closable={true}
          onClose={hideDrawerCancel}
          footer={
            <div style={{ textAlign: 'right' }}>
              <Button onClick={hideDrawerCancel} style={{ marginRight: 8 }}>
                Cancel
              </Button>
              <Button onClick={hideDrawerOk} type="primary">
                Submit
              </Button>
            </div>
          }
          width="70%"
          bodyStyle={{ padding: '16px', overflow: 'auto' }}
        >
          <Form
            {...layout}
            name="basic"
            form={form}
            onFinish={formOnFinish}
          >
            <Form.Item
              label="Override Name"
              name="name"
              rules={[{ required: true, message: 'Please enter the override name!' }]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              label="Default Capabilities"
              name="defaultCapabilities"
            >
              <Select
                mode="multiple"
                placeholder="Select default capabilities"
                options={capabilities.map(capability => ({
                  label: capability.name,
                  value: capability._id,
                }))}
              />
            </Form.Item>
            <Form.Item
              label="Default Ressources"
              name="defaultRessources"
            >
              <Select
                mode="multiple"
                placeholder="Select default resources"
                options={resources.map(resource => ({
                  label: resource.name,
                  value: resource._id,
                }))}
              />
            </Form.Item>
          </Form>
        </Drawer>
      </>
    );
  };
  

export default EditOverride;
